import { useMemo } from 'react'
import { useMediaQuery } from 'usehooks-ts'

import profileRandomAlcoveStudioMobile from '@/public/images/profile-random/alcove-studio@mobile.jpg'
import profileRandomAlcoveStudioPc from '@/public/images/profile-random/alcove-studio@pc.jpg'
import profileRandomDefaultMobile from '@/public/images/profile-random/default@mobile.jpg'
import profileRandomDefaultPc from '@/public/images/profile-random/default@pc.jpg'
import profileRandomDesertNightMobile from '@/public/images/profile-random/desert-night@mobile.jpg'
import profileRandomDesertNightPc from '@/public/images/profile-random/desert-night@pc.jpg'
import profileRandomDuplexGalleryMobile from '@/public/images/profile-random/duplex-gallery@mobile.jpg'
import profileRandomDuplexGalleryPc from '@/public/images/profile-random/duplex-gallery@pc.jpg'
import profileRandomGradientMobile from '@/public/images/profile-random/gradient@mobile.jpg'
import profileRandomGradientPc from '@/public/images/profile-random/gradient@pc.jpg'
import profileRandomRooftopPoolMobile from '@/public/images/profile-random/rooftop-pool@mobile.jpg'
import profileRandomRooftopPoolPc from '@/public/images/profile-random/rooftop-pool@pc.jpg'
import profileRandomSkyIslandMobile from '@/public/images/profile-random/sky-island@mobile.jpg'
import profileRandomSkyIslandPc from '@/public/images/profile-random/sky-island@pc.jpg'
import profileRandomSpaceMobile from '@/public/images/profile-random/space@mobile.jpg'
import profileRandomSpacePc from '@/public/images/profile-random/space@pc.jpg'
import profileRandomTatamiRoomMobile from '@/public/images/profile-random/tatami-room@mobile.jpg'
import profileRandomTatamiRoomPc from '@/public/images/profile-random/tatami-room@pc.jpg'

const banners = [
  {
    pc: profileRandomDefaultPc,
    mobile: profileRandomDefaultMobile,
  },
  {
    pc: profileRandomAlcoveStudioPc,
    mobile: profileRandomAlcoveStudioMobile,
  },
  {
    pc: profileRandomDesertNightPc,
    mobile: profileRandomDesertNightMobile,
  },
  {
    pc: profileRandomDuplexGalleryPc,
    mobile: profileRandomDuplexGalleryMobile,
  },
  {
    pc: profileRandomGradientPc,
    mobile: profileRandomGradientMobile,
  },
  {
    pc: profileRandomRooftopPoolPc,
    mobile: profileRandomRooftopPoolMobile,
  },
  {
    pc: profileRandomSkyIslandPc,
    mobile: profileRandomSkyIslandMobile,
  },
  {
    pc: profileRandomSpacePc,
    mobile: profileRandomSpaceMobile,
  },
  {
    pc: profileRandomTatamiRoomPc,
    mobile: profileRandomTatamiRoomMobile,
  },
]

const getRandomChild = <T>(array: T[]): T => {
  const index = Math.floor(Math.random() * array.length)
  return array[index]
}

export const useRandomBanner = () => {
  const matched1440 = useMediaQuery('(min-width: 1440px)')

  const randomBanner = useMemo(() => getRandomChild(banners), [])

  return matched1440 ? randomBanner.pc : randomBanner.mobile
}
